export function zLen(str, len) {
  while (str.length < len) {
    str = "0" + str;
  }
  return str;
}

export function grabFirstLastNames(input) {
  if (input) {
    let name = input.split(' ');
    if (name.length === 1) {
      return {
        fname: name[0],
        lname: ""
      }
    }
    return {
      fname: name[0],
      lname: name[name.length - 1]
    }
  } else {
    return {
      fname: "",
      lname: ""
    }
  }
}

export function splitBy(inStr, split) {
  return inStr.split(split);
}

export function prettyFlatObject(obj) {
  return Object.keys(obj).filter((o) => obj[o] && obj[o].length > 0).map((o) => [o.replaceAll(/_/g, " "), obj[o]].join(": "));
}

export function trimJoin(strArray, joinBy = " ") {
  return [...strArray].map((val) => val && val.trim() || "").filter((val) => val.length > 0).join(joinBy);
}

export function prependIf(str, prepend = "") {
  if (str && str.length > 0) {
    return prepend + str;
  }
  return str;
}

export function getDataLine(arrayConditions, displayCB, displayOther, joinBy = " ") {
  var arr = [];
  arrayConditions.forEach((val) => {
    if (val !== undefined && val !== "") {
      arr.push(val);
    }
  });
  if (!displayCB && arr.length > 0) return arr.join(joinBy);
  if (!displayCB && arr.length === 0) return displayOther || "";
  if (arr.length !== arrayConditions.length) return displayOther || "";
  return displayCB(arr) || displayOther || "";
}

export function addLine(str, newData) {
  return str + newData + "\n";
}

export function emptyDefault(val, defaultVal) {
  return (val === undefined || val === "") ? defaultVal : val;
}


// WEBPACK FOOTER //
// ./src/util/stringhelpers.js